import React from 'react';

import { useThemedStyles } from '../../hooks/useThemedStyles';
import Text from '../text/Text';

export const TypographyHeading = ({
	label,
	style,
	subheadingSmall,
	subheadingSmallSubtle,
	fieldLabel,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<Text style={[
			styles.heading,
			subheadingSmall && styles.subheadingSmall,
			subheadingSmallSubtle && styles.subheadingSmallSubtle,
			fieldLabel && styles.fieldLabel,
			style,
		]}>
			{label}
		</Text>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	heading: {
		...type.cardTitle,
		marginRight: 4,
		marginTop: 4,
		color: colors.text,
	},
	subheadingSmall: {
		...type.label,
		color: colors.textSecondary,
	},
	subheadingSmallSubtle: {
		...type.caption,
		color: colors.textFaint,
	},
	// Label above a form field: the one form label style (type.fieldLabel).
	fieldLabel: {
		...type.fieldLabel,
		color: colors.text,
		marginTop: space.xs,
		marginBottom: 6,
	},
});
